export default function announcementModal() {
  const modalNamespace = 'announcement-modal';
  const modalEl = document.getElementById(modalNamespace);

  if (modalEl) {
    const storageName = 'announcement-modal-dismissed';
    const { cookie: cookieValue } = modalEl.dataset;
    const cookieStorage = localStorage.getItem(storageName);
    const modal = window.modalManager.idModalMap.get(modalNamespace);

    if (!cookieStorage || cookieStorage !== cookieValue) {
      modal.show();

      // set local storage to prevent showing the modal again
      modalEl.querySelectorAll('a').forEach(el => {
        el.addEventListener('click', () => {
          localStorage.setItem(storageName, cookieValue);
        });
      });

      // close modal cookie
      modal.on('before-hide', () => {
        localStorage.setItem(storageName, cookieValue);
      });
    }
  }
}
